<div class="card infosection">
  <img class="header-img" [src]="s3Url + '/logo-icons/' + merchantName + '-logo-icon.png'" />
  <div *ngIf="showcta" class="header-text"> Shop now and pay later at your favourite store using Zestmoney EMIs</div>
  <div *ngIf="showcta" class="container">
    <div class="info step" *ngFor="let step of steps">
      <span class="step-count">{{step.step}}</span>
      <img src="{{step.image}}">
      <div class="text">{{step.text}}</div>
    </div>
    <button class="btn btn-block waves-effect zest-btn" (click)="openModal()"> GET VOUCHER NOW </button>
  </div>
</div>

<div id="GenVoucherModal" [ngClass]="{modal: true, 'bottom-sheet': !isDesktop}" materialize="modal"
  [materializeParams]="[{dismissible: false}]">
  <ng-container *ngIf="page === 0">
    <div class="modal-header">
      <h2>Important Note</h2>
      <button (click)="closeModal()" class="close btn-flat btn"><img src="/assets/images/offlineGC/x.png"
          alt=""></button>
    </div>
    <div class="modal-content counter">
      <img src="/assets/images/offlineGC/amount.jpg">
      <div>Are you at the cash counter and the cashier has given you the invoice?</div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="closeModal()" class="btn modal-btn zest-btn-2-inverted waves-effect"
        [textContent]="'No'"></button>
      <button type="button" (click)="showAmtModal()" class="btn zest-btn-2 modal-btn waves-effect"
        [textContent]="'Yes'"></button>
    </div>
  </ng-container>
  <ng-container *ngIf="page === 1">
    <div class="modal-header">
      <h2>Voucher Amount</h2>
      <button (click)="closeModal()" class="close btn-flat btn"><img src="/assets/images/offlineGC/x.png"
          alt=""></button>
    </div>
    <div class="modal-content counter">
      <img src="/assets/images/offlineGC/voucher.jpg">
      <div>Please enter the amount that the cashier has told you to pay below</div>
    </div>
    <div class="modal-footer">
      <div class="input-group">
        <form (submit)="submit()">
          <input autofocus materialize id="voucher_amount" class="currency" name="voucher_amount" type="tel" required
            autocomplete="off" [textMask]="rupeeCommaNumberMask" minlength="5" maxlength="7" pattern="^[1-9][0-9,]*$"
            [placeholder]="'Enter voucher amount'" #voucher_amt="ngModel" [(ngModel)]="voucherAmount"
            (ngModelChange)="voucherAmtChange()" />
          <span class="info" *ngIf="maxAmt > minAmt">Amount must be from {{minAmt | RupeeCurrencyPipe : true}} to
            {{maxAmt | RupeeCurrencyPipe : true}}</span>
          <span class="info text-red" *ngIf="maxAmt < minAmt">Available credit limit is less than
            {{minAmt | RupeeCurrencyPipe : true}}
          </span>
          <span class="info" *ngIf="maxAmt == minAmt">Amount should be {{minAmt | RupeeCurrencyPipe : true}}
          </span>
          <button type="submit" [disabled]="!voucherAmtvalid" [ngClass]="'btn zest-btn-2 modal-btn waves-effect'">
            <img src="/assets/images/offlineGC/arrow-back.png">
          </button>
        </form>
      </div>
    </div>
  </ng-container>
</div>